



































































import {Component, Vue} from 'vue-property-decorator';
import Modal from '@/components/UI/Modal.vue';
import {PromoThresholdSegment, PromoCarouselProduct} from '@/store/models';
import cart from '@/store/modules/cart';
import ui from '@/store/modules/ui';
import store from '@/store';
import {getPromoCarouselProducts, getPromoCarouselProduct} from '@/store/api';
import {Carousel, Slide} from 'vue-carousel';
import ProductGallery from '@/components/Cart/ProductGallery.vue';
import Progress from '@/components/UI/Progress.vue';
import gtmhelpers from '@/commons/gtmhelpers';

@Component({
    components: {
        Modal,
        Carousel,
        Slide,
        ProductGallery,
        Progress,
    }
})
export default class PromoCarousel extends Vue {
    private loading: boolean = false;
    private addingToCart: any = [];
    private carouselProducts: PromoCarouselProduct[] = [];
    private selectedSizes: any = {};
    private warnings: any = {};

    get promoThresholds(): PromoThresholdSegment[] {
        const segments: PromoThresholdSegment[] = cart.totals.extension_attributes.blackbox_response.promo_threshold;
        return segments;
    }

    private loadVariant(productId: string, colorVariantId: string) {
        const idxToReplace = this.carouselProducts.findIndex((prod) => prod.id === parseInt(productId));
        getPromoCarouselProduct(colorVariantId).then((carouselProduct: PromoCarouselProduct) => {
            this.carouselProducts.splice(idxToReplace, 1, carouselProduct);
        });
    }

    private getDiscountPercent(product: PromoCarouselProduct) {
        const price = product.price;
        const specialPrice = product.final_price;
        return Math.round(((price - specialPrice) / price) * 100);
    }

    private addToCart(product: PromoCarouselProduct, promoId: string) {
        this.warnings = {};
        this.addingToCart = [];
        const pid = product.id;
        const size = this.selectedSizes[product.id];
        const sizeAttId = store.state.options.catalog.size_attribute_id;
        if (!size) {
            this.warnings[pid] = this.$t('Select the size').toString();
            return;
        }
        const addData = {sku: product.sku, sizeConfiguration: {option_id: sizeAttId, option_value: size}};
        this.addingToCart[pid] = true;
        cart.addCartItem(addData)
            .then((cartItem: any) => {
                gtmhelpers.trackAdd(gtmhelpers.convertProductsData([cartItem]), cart.totals.quote_currency_code);
                gtmhelpers.gtmPush({event: 'add_to_cart_promo_carousel'});
                this.toggleModal(false, promoId, '');
                this.selectedSizes = {};
            }).catch((e: any) => {
                this.warnings[pid] = e.message;
        }).finally(() => {
            this.addingToCart = [];
        });
    }

    private trackProductLink(url: string) {
        gtmhelpers.trackSimpleEvent('click_product_promo_carousel');
        document.location.href = url;
    }
    private trackSelectPromo(promoId: string, promoType: string) {
        gtmhelpers.trackPromoCarouselShow('select_promo_carousel', promoType);
    }
    private toggleModal(direction: boolean, promoId: string, promoType: string) {
        const modalId = 'promo' + promoId;
        if (direction) {
            this.loading = true;
            getPromoCarouselProducts(promoId).then((carouselProducts: PromoCarouselProduct[]) => {
                this.carouselProducts = carouselProducts;
                ui.openModal(modalId);
                gtmhelpers.trackPromoCarouselShow('view_promo_carousel', promoType);
                this.loading = false;
            });
        } else {
            ui.closeModal(modalId);
        }
    }
}
